import config from 'config/appConfig';

export class TermsHelper {
  /**
   * 利用規約のプレビューURLを取得します。
   */
  static getPreviewUrl(companyCd: string): string {
    return `${config.url.userWeb}/terms/preview/${companyCd}`;
  }

  /**
   * 利用規約のプレビューURLを開きます。
   */
  static openPreviewUrl(companyCd: string): void {
    window.open(this.getPreviewUrl(companyCd), '_blank');
  }

  /**
   * 利用規約の公開URLを取得します。
   */
  static getProductionUrl(companyCd: string): string {
    return `${config.url.userWeb}/terms/${companyCd}`;
  }

  /**
   * 利用規約の公開URLを開きます。
   */
  static openProductionUrl(companyCd: string): void {
    window.open(this.getProductionUrl(companyCd), '_blank');
  }
}
